// Sites — typed operations against graphql-bff's createAsset / updateAsset
// mutations (the `assets` table, tenant-scoped by the principal). Hand-typed in
// the queriesTickets style; move into queries.ts and run `npm run codegen`
// once the schema is regenerated. The selection set mirrors TenantAssetsQuery
// so urql's document cache invalidates every `Asset` consumer on success.

import type { ResultOf } from "@graphql-typed-document-node/core";
import type { TypedDocumentNode } from "@graphql-typed-document-node/core";
import { parse } from "graphql";

import { TenantAssetsQuery } from "@/app/queries";

/** One row of `tenantAssets` — the shape every site consumer already uses. */
export type SiteAsset = ResultOf<typeof TenantAssetsQuery>["tenantAssets"][number];

const ASSET_FIELDS = /* GraphQL */ `
  id tenantId name locationState latitude longitude capacityMwh powerRatingMw
  socMinPct socMaxPct cRate roundTripEfficiencyPct bmsHost bmsPort bmsUnitId pollIntervalSeconds
`;

export interface CreateAssetInput {
  name: string;
  locationState: string;
  powerRatingMw: number;
  capacityMwh: number;
  latitude?: number | null;
  longitude?: number | null;
  socMinPct?: number | null;
  socMaxPct?: number | null;
  roundTripEfficiencyPct?: number | null;
  cRate?: number | null;
}

/** Partial edit: omitted fields are unchanged, an explicit null clears an optional one. */
export interface UpdateAssetInput {
  name?: string;
  locationState?: string;
  latitude?: number | null;
  longitude?: number | null;
  capacityMwh?: number;
  powerRatingMw?: number;
  socMinPct?: number;
  socMaxPct?: number;
  roundTripEfficiencyPct?: number | null;
  cRate?: number | null;
}

export const CreateAssetDocument = parse(/* GraphQL */ `
  mutation CreateAsset($input: CreateAssetInput!) { createAsset(input: $input) { ${ASSET_FIELDS} } }
`) as TypedDocumentNode<{ createAsset: SiteAsset }, { input: CreateAssetInput }>;

export const UpdateAssetDocument = parse(/* GraphQL */ `
  mutation UpdateAsset($id: Int!, $input: UpdateAssetInput!) { updateAsset(id: $id, input: $input) { ${ASSET_FIELDS} } }
`) as TypedDocumentNode<{ updateAsset: SiteAsset }, { id: number; input: UpdateAssetInput }>;
